/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as FriendsRouteImport } from './routes/friends'
import { Route as GamesRouteImport } from './routes/games'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as StoreRouteImport } from './routes/store'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as AdminProductsRouteImport } from './routes/admin/products'
import { Route as AdminSessionsRouteImport } from './routes/admin/sessions'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as GameInviteCodeRouteImport } from './routes/gameInvite.$code'
import { Route as GamesGameIdRouteImport } from './routes/games.$gameId'
import { Route as HotseatSessionIdRouteImport } from './routes/hotseat.$sessionId'
import { Route as InviteInviteIdRouteImport } from './routes/invite.$inviteId'
import { Route as LibraryGameIdRouteImport } from './routes/library.$gameId'
import { Route as SessionSessionIdRouteImport } from './routes/session.$sessionId'
import { Route as StoreGameIdRouteImport } from './routes/store.$gameId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const FriendsRoute = FriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesRoute = GamesRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreRoute = StoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminSessionsRoute = AdminSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const GameInviteCodeRoute = GameInviteCodeRouteImport.update({
  id: '/gameInvite/$code',
  path: '/gameInvite/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const GamesGameIdRoute = GamesGameIdRouteImport.update({
  id: '/$gameId',
  path: '/$gameId',
  getParentRoute: () => GamesRoute,
} as any)
const HotseatSessionIdRoute = HotseatSessionIdRouteImport.update({
  id: '/hotseat/$sessionId',
  path: '/hotseat/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteInviteIdRoute = InviteInviteIdRouteImport.update({
  id: '/invite/$inviteId',
  path: '/invite/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryGameIdRoute = LibraryGameIdRouteImport.update({
  id: '/$gameId',
  path: '/$gameId',
  getParentRoute: () => LibraryRoute,
} as any)
const SessionSessionIdRoute = SessionSessionIdRouteImport.update({
  id: '/session/$sessionId',
  path: '/session/$sessionId',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreGameIdRoute = StoreGameIdRouteImport.update({
  id: '/$gameId',
  path: '/$gameId',
  getParentRoute: () => StoreRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/friends': typeof FriendsRoute
  '/games': typeof GamesRouteWithChildren
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/store': typeof StoreRouteWithChildren
  '/verify': typeof VerifyRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/sessions': typeof AdminSessionsRoute
  '/admin/users': typeof AdminUsersRoute
  '/gameInvite/$code': typeof GameInviteCodeRoute
  '/games/$gameId': typeof GamesGameIdRoute
  '/hotseat/$sessionId': typeof HotseatSessionIdRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/library/$gameId': typeof LibraryGameIdRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
  '/store/$gameId': typeof StoreGameIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/friends': typeof FriendsRoute
  '/games': typeof GamesRouteWithChildren
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/store': typeof StoreRouteWithChildren
  '/verify': typeof VerifyRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/sessions': typeof AdminSessionsRoute
  '/admin/users': typeof AdminUsersRoute
  '/gameInvite/$code': typeof GameInviteCodeRoute
  '/games/$gameId': typeof GamesGameIdRoute
  '/hotseat/$sessionId': typeof HotseatSessionIdRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/library/$gameId': typeof LibraryGameIdRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
  '/store/$gameId': typeof StoreGameIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/friends': typeof FriendsRoute
  '/games': typeof GamesRouteWithChildren
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/settings': typeof SettingsRoute
  '/store': typeof StoreRouteWithChildren
  '/verify': typeof VerifyRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/sessions': typeof AdminSessionsRoute
  '/admin/users': typeof AdminUsersRoute
  '/gameInvite/$code': typeof GameInviteCodeRoute
  '/games/$gameId': typeof GamesGameIdRoute
  '/hotseat/$sessionId': typeof HotseatSessionIdRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/library/$gameId': typeof LibraryGameIdRoute
  '/session/$sessionId': typeof SessionSessionIdRoute
  '/store/$gameId': typeof StoreGameIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/friends'
    | '/games'
    | '/history'
    | '/library'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/store'
    | '/verify'
    | '/admin/products'
    | '/admin/sessions'
    | '/admin/users'
    | '/gameInvite/$code'
    | '/games/$gameId'
    | '/hotseat/$sessionId'
    | '/invite/$inviteId'
    | '/library/$gameId'
    | '/session/$sessionId'
    | '/store/$gameId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/friends'
    | '/games'
    | '/history'
    | '/library'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/store'
    | '/verify'
    | '/admin/products'
    | '/admin/sessions'
    | '/admin/users'
    | '/gameInvite/$code'
    | '/games/$gameId'
    | '/hotseat/$sessionId'
    | '/invite/$inviteId'
    | '/library/$gameId'
    | '/session/$sessionId'
    | '/store/$gameId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/friends'
    | '/games'
    | '/history'
    | '/library'
    | '/login'
    | '/reset-password'
    | '/settings'
    | '/store'
    | '/verify'
    | '/admin/products'
    | '/admin/sessions'
    | '/admin/users'
    | '/gameInvite/$code'
    | '/games/$gameId'
    | '/hotseat/$sessionId'
    | '/invite/$inviteId'
    | '/library/$gameId'
    | '/session/$sessionId'
    | '/store/$gameId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  FriendsRoute: typeof FriendsRoute
  GamesRoute: typeof GamesRouteWithChildren
  HistoryRoute: typeof HistoryRoute
  LibraryRoute: typeof LibraryRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SettingsRoute: typeof SettingsRoute
  StoreRoute: typeof StoreRouteWithChildren
  VerifyRoute: typeof VerifyRoute
  GameInviteCodeRoute: typeof GameInviteCodeRoute
  HotseatSessionIdRoute: typeof HotseatSessionIdRoute
  InviteInviteIdRoute: typeof InviteInviteIdRoute
  SessionSessionIdRoute: typeof SessionSessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/friends': {
      id: '/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof FriendsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games': {
      id: '/games'
      path: '/games'
      fullPath: '/games'
      preLoaderRoute: typeof GamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/sessions': {
      id: '/admin/sessions'
      path: '/sessions'
      fullPath: '/admin/sessions'
      preLoaderRoute: typeof AdminSessionsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/gameInvite/$code': {
      id: '/gameInvite/$code'
      path: '/gameInvite/$code'
      fullPath: '/gameInvite/$code'
      preLoaderRoute: typeof GameInviteCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/games/$gameId': {
      id: '/games/$gameId'
      path: '/$gameId'
      fullPath: '/games/$gameId'
      preLoaderRoute: typeof GamesGameIdRouteImport
      parentRoute: typeof GamesRoute
    }
    '/hotseat/$sessionId': {
      id: '/hotseat/$sessionId'
      path: '/hotseat/$sessionId'
      fullPath: '/hotseat/$sessionId'
      preLoaderRoute: typeof HotseatSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$inviteId': {
      id: '/invite/$inviteId'
      path: '/invite/$inviteId'
      fullPath: '/invite/$inviteId'
      preLoaderRoute: typeof InviteInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/$gameId': {
      id: '/library/$gameId'
      path: '/$gameId'
      fullPath: '/library/$gameId'
      preLoaderRoute: typeof LibraryGameIdRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/session/$sessionId': {
      id: '/session/$sessionId'
      path: '/session/$sessionId'
      fullPath: '/session/$sessionId'
      preLoaderRoute: typeof SessionSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store/$gameId': {
      id: '/store/$gameId'
      path: '/$gameId'
      fullPath: '/store/$gameId'
      preLoaderRoute: typeof StoreGameIdRouteImport
      parentRoute: typeof StoreRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminProductsRoute: typeof AdminProductsRoute
  AdminSessionsRoute: typeof AdminSessionsRoute
  AdminUsersRoute: typeof AdminUsersRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminProductsRoute: AdminProductsRoute,
  AdminSessionsRoute: AdminSessionsRoute,
  AdminUsersRoute: AdminUsersRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface GamesRouteChildren {
  GamesGameIdRoute: typeof GamesGameIdRoute
}

const GamesRouteChildren: GamesRouteChildren = {
  GamesGameIdRoute: GamesGameIdRoute,
}

const GamesRouteWithChildren = GamesRoute._addFileChildren(GamesRouteChildren)

interface LibraryRouteChildren {
  LibraryGameIdRoute: typeof LibraryGameIdRoute
}

const LibraryRouteChildren: LibraryRouteChildren = {
  LibraryGameIdRoute: LibraryGameIdRoute,
}

const LibraryRouteWithChildren =
  LibraryRoute._addFileChildren(LibraryRouteChildren)

interface StoreRouteChildren {
  StoreGameIdRoute: typeof StoreGameIdRoute
}

const StoreRouteChildren: StoreRouteChildren = {
  StoreGameIdRoute: StoreGameIdRoute,
}

const StoreRouteWithChildren = StoreRoute._addFileChildren(StoreRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  FriendsRoute: FriendsRoute,
  GamesRoute: GamesRouteWithChildren,
  HistoryRoute: HistoryRoute,
  LibraryRoute: LibraryRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SettingsRoute: SettingsRoute,
  StoreRoute: StoreRouteWithChildren,
  VerifyRoute: VerifyRoute,
  GameInviteCodeRoute: GameInviteCodeRoute,
  HotseatSessionIdRoute: HotseatSessionIdRoute,
  InviteInviteIdRoute: InviteInviteIdRoute,
  SessionSessionIdRoute: SessionSessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
